export const SET_KPI_EVALUATION_REQUEST = "SET_KPI_EVALUATION_REQUEST";
export const SET_KPI_EVALUATION_SUCCESS = "SET_KPI_EVALUATION_SUCCESS";
export const SET_KPI_EVALUATION_ERROR = "SET_KPI_EVALUATION_ERROR";